import { useCallback } from 'react'
import { useQueryClient } from 'react-query'
import {
  MAR_CHART_QUERY_KEY,
  MEDICATION_SCHEDULE_PATTERN_QUERY_KEY,
  MEDICATION_SCHEDULE_PATTERNS_QUERY_KEY,
  STOCK_LOGS_QUERY_KEY
} from './queryConstants'

/**
 * Marks every cached read a change to a medication can affect as stale: the
 * resident's pattern list and MAR chart, the single pattern behind the
 * medication information page, and that medication's stock log.
 *
 * Call it after any successful write to a medication. The client holds queries
 * fresh for five minutes (see createQueryClient), so a screen mounted straight
 * after a save otherwise renders the pre-save data until that window lapses or
 * the page is reloaded — which is what ROST-2596 reported for the edit
 * configuration form's end date.
 */
export const useInvalidateMedicationQueries = () => {
  const queryClient = useQueryClient()

  return useCallback(() => {
    queryClient.invalidateQueries([MEDICATION_SCHEDULE_PATTERNS_QUERY_KEY])
    queryClient.invalidateQueries([MEDICATION_SCHEDULE_PATTERN_QUERY_KEY])
    queryClient.invalidateQueries([MAR_CHART_QUERY_KEY])
    queryClient.invalidateQueries([STOCK_LOGS_QUERY_KEY])
  }, [queryClient])
}

export default useInvalidateMedicationQueries
